export default "__VITE_ASSET__DM59Xsi7__"